import React, { useRef, useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';

const PDFViewer = ({ images, onClose, onBookNow, title }) => {
  const scrollRef = useRef(null);
  const [showScrollHint, setShowScrollHint] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      if (!scrollRef.current) return;
      setShowScrollHint(scrollRef.current.scrollTop < 10);
    };
    const el = scrollRef.current;
    if (el) el.addEventListener('scroll', handleScroll);
    return () => { if (el) el.removeEventListener('scroll', handleScroll); };
  }, []);

  return (
    <div className="core__modal" onClick={onClose}>
      <div className="core__modal-content" onClick={e => e.stopPropagation()} style={{ display: 'flex', flexDirection: 'column', maxHeight: '90vh' }}>
        <div className="core__modal-header">
          <h3>{title}</h3>
          <button className="core__modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>
        <div ref={scrollRef} className="pdfviewer__scroll-area" style={{ flex: 1, overflowY: 'scroll', display: 'flex', flexDirection: 'column', gap: '2rem', alignItems: 'center', padding: '0.5rem', position: 'relative' }}>
          {images.map((img, idx) => (
            <img
              key={idx}
              src={img}
              alt={`PDF page ${idx + 1}`}
              style={{ maxWidth: '100%', boxShadow: '0 2px 8px rgba(0,0,0,0.10)', background: '#fff' }}
            />
          ))}
          {showScrollHint && (
            <div className="pdfviewer__scroll-hint">
              <span className="pdfviewer__scroll-arrow">↓</span>
            </div>
          )}
        </div>
        <div className="core__modal-buttons" style={{ padding: '1.5rem 2rem', borderTop: '1px solid #f0f0f0', background: '#fff', justifyContent: 'center' }}>
          <button className="button" onClick={onBookNow}>
            Book Now
          </button>
        </div>
      </div>
    </div>
  );
};

export default PDFViewer; 